export const holiduCancelReasons = [
  { id: 'PROVIDER_NO_PAYMENT', label: $localize`No Payment` },
  { id: 'PROVIDER_OVERBOOKED', label: 'Overbooked' },
  { id: 'CUSTOMER_WRONG_PRICE', label: $localize`Wrong Price` },
  { id: 'CUSTOMER_WRONG_FACILITIES', label: $localize`Wrong Facilities` },
  { id: 'CUSTOMER_UNKNOWN_REASON', label: $localize`Unknown Reason` },
  { id: 'CUSTOMER_REBOOKING', label: 'Rebooking' },
  { id: 'CUSTOMER_PERSONAL', label: 'Personal' },
  { id: 'CUSTOMER_ALTERNATIVE_HOLIDU_PRICE', label: $localize`Alternative Holidu Price` },
  { id: 'CUSTOMER_ALTERNATIVE_HOLIDU_LOCATION', label: $localize`Alternative Holidu Location` },
  { id: 'CUSTOMER_ALTERNATIVE_HOLIDU_OTHER', label: $localize`Alternative Holidu Other` },
  { id: 'CUSTOMER_ALTERNATIVE_ELSEWHERE_PRICE', label: $localize`Alternative Elsewhere Price` },
  { id: 'CUSTOMER_ALTERNATIVE_ELSEWHERE_LOCATION', label: $localize`Alternative Elsewhere Location` },
  { id: 'CUSTOMER_ALTERNATIVE_ELSEWHERE_OTHER', label: $localize`Alternative Elsewhere Other` },
  { id: 'CUSTOMER_TRAVEL_RESTRICTIONS_VISA', label: $localize`Travel Restrictions visa` },
  { id: 'CUSTOMER_TRAVEL_RESTRICTIONS_COVID', label: $localize`Travel Restrictions Covid` },
  { id: 'CUSTOMER_TRAVEL_RESTRICTIONS_OTHER', label: $localize`Travel Restrictions Other` },
  { id: 'CUSTOMER_PROVIDER_REQUEST_BOOK_ELSEWHERE', label: $localize`Provider Request Book Elsewhere` },
  { id: 'CUSTOMER_PROVIDER_REQUEST_AVAILABILITY', label: $localize`Provider Request Availability` },
  { id: 'CUSTOMER_PROVIDER_REQUEST_OTHER', label: $localize`Provider Request Other` },
  { id: 'CUSTOMER_PROPERTY_QUALITY', label: $localize`Property Quality` },
  { id: 'CUSTOMER_OTHER', label: 'Other' },
]
